module.exports = __webpack_public_path__ + "img/37_16.7895a376.png";